module.exports = __webpack_public_path__ + "img/cloud-sun-02.4d359993.svg";